import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable, Subscription, fromEvent } from 'rxjs';
import { Router } from '@angular/router';
import { ACCOUNT } from './constants/routes';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})

export class AppComponent implements OnInit, OnDestroy {
  consoleMessage: string = "This feature is intended for developers only ";
  consoleStyle: string = "color: #900968; font-size: 28px;font-weight: bold;";

  onlineEvent: Observable<Event>;
  offlineEvent: Observable<Event>;
  subscriptions: Subscription[] = [];
  connectionStatusMessage: string;
  connectionStatus: string;

  constructor(private _router: Router) {
    console.log(`%c${this.consoleMessage}`, this.consoleStyle);
  }

  ngOnInit() {
    // this.preventChangesOfLocalStorage();
    this.chechStatus();
  }

  /**
   * @ONLINE_OFFLINE Get the online/offline status from browser window
   */
  chechStatus() {
    this.onlineEvent = fromEvent(window, 'online');
    this.offlineEvent = fromEvent(window, 'offline');

    this.subscriptions.push(this.onlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Back to online';
      this.connectionStatus = 'online';

    }));

    this.subscriptions.push(this.offlineEvent.subscribe(e => {
      this.connectionStatusMessage = 'Connection lost! please check your internet connection';
      // this.connectionStatusMessage = 'Connection lost! You are not connected to Internet';
      this.connectionStatus = 'offline';
    }));
  }

  /**
   * @UNSUBSCRIPTION Unsubscribe all subscriptions to avoid memory leak
   */
  ngOnDestroy() {
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
